exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification-settings-loader__select{display:block;position:relative;margin-bottom:24px}.notification-settings-loader__wrap{position:relative;width:100%;height:51px;-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:14px 0 12px;font-weight:400;font-size:16px;line-height:1.5;color:#333;border:none;border-radius:0;border-bottom:1px solid #ddd;outline:none;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/main/userprofile/tab-settings/notification-settings/loader/style.scss
// module id = 1278
// module chunks = 62